import { render } from "./UploadProgress.vue?vue&type=template&id=242fc060&scoped=true&ts=true"
import script from "./UploadProgress.vue?vue&type=script&lang=ts"
export * from "./UploadProgress.vue?vue&type=script&lang=ts"

import "./UploadProgress.vue?vue&type=style&index=0&id=242fc060&lang=css"
import "./UploadProgress.vue?vue&type=style&index=1&id=242fc060&lang=less&scoped=true"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242fc060"]])

export default __exports__